import { ButtonView } from '@shared/components/View';
import { grid } from '@shared/styles';
import { useGoogleMapsImageUrl, useOpenMap } from './utils';
import styles from './GeolocationMapPreview.module.css';

interface GeolocationMapPreviewProps {
  lat: number;
  lon: number;
  width?: number | string;
  height?: number | string;
  iconUrl?: string;
}

export function GeolocationMapPreview({
  lat,
  lon,
  iconUrl,
  width = '100%',
  height = grid(12),
}: GeolocationMapPreviewProps) {
  const openMap = useOpenMap(lat, lon);
  const googleMapsImageUrl = useGoogleMapsImageUrl({
    lat,
    lon,
    iconUrl,
    scale: 1,
    zoom: 15,
    size: '400x400',
  });

  return (
    <ButtonView className={styles.geolocationPreview} onClick={openMap}>
      <img src={googleMapsImageUrl} alt="" className={styles.image} style={{ width, height }} />
    </ButtonView>
  );
}
